module.exports = " <div class=weui_tab> <slot name=header></slot> <div class=\"weui_tab_bd vux-fix-safari-overflow-scrolling\" v-el:view-box-body> <slot></slot> </div> <slot name=bottom></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/view-box/index.vue
// module id = 260
// module chunks = 2